import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { PageMetricsProvider, MetricsTracker } from '@sm/metrics';

import { ExperimentProvider } from '../Experiments';
import BasePageHead from './BasePageHead';
import { StaticContext } from '../..';
import BasePageBody, {
  propTypes as basePageBodyPropTypes,
  defaultProps as basePageBodyDefaultProps,
} from './BasePageBody';
import { useGTM, useInitialRender } from './hooks';

const BasePage = ({
  children,
  pageId,
  pageMetricsAttributes,
  legacyWeb,
  includeExperiments,
  ...bodyProps
}) => {
  const isInitialRender = useInitialRender();
  const { user, environment, 'client-config': clientConfig, GDPR } = useContext(
    StaticContext
  );
  const { countryCode: country } = environment;
  const {
    gtmId,
    mixpanelToken,
    loggingAPIPath,
    dataAnalyticsAPIPath,
    amplitudeToken,
  } = clientConfig;

  // init global metrics
  if (isInitialRender) {
    MetricsTracker.initialize({
      user,
      dataAnalyticsAPIPath,
      loggingAPIPath,
      country,
      legacyWeb,
      pageId,
      gtmId,
      mixpanelToken,
      amplitudeToken,
    });
  }
  useGTM();

  const BasePageInternals = (
    <PageMetricsProvider
      pageId={pageId}
      attributes={pageMetricsAttributes}
      GDPR={GDPR}
      user={user}
      country={country}
    >
      <BasePageHead isPrivateLabel={bodyProps.isPrivateLabel} />
      <BasePageBody {...bodyProps}>{children}</BasePageBody>
    </PageMetricsProvider>
  );

  if (includeExperiments) {
    return <ExperimentProvider>{BasePageInternals}</ExperimentProvider>;
  }

  return BasePageInternals;
};

BasePage.propTypes = {
  legacyWeb: PropTypes.string.isRequired,
  includeExperiments: PropTypes.bool,
  pageId: PropTypes.string.isRequired,
  pageMetricsAttributes: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  ...basePageBodyPropTypes,
};

BasePage.defaultProps = {
  includeExperiments: true,
  pageMetricsAttributes: null,
  ...basePageBodyDefaultProps,
};

export default BasePage;
